import { UserConfiguration } from '@app/models/user/user-configuration.model';

export const mockUserConfiguration: UserConfiguration = {
  notificationsViaEmailEnabled: true,
  notificationsViaSlackEnabled: true,
  notificationsViaTeamsEnabled: true,
  preferredLocale: 'en'
}